module.exports = __webpack_public_path__ + "img/protocase.20de0840.png";